import { getObjectUtil } from 'packages/src'
import EXERCISES_PATH from '../../constants/path'

export const getPageExerciseUiSelect = state => (
  getObjectUtil(state, EXERCISES_PATH.PAGE) || 1
)
